export const shareTitleListPageInitValue = {
  data: {
    shareTitleTotal: 0,
    activeShareTitleTotal: 0,
    shareTitles: [],
    societyShareTitleDocument: null,
    societyId: '',
    societyName: '',
    corporateId: '',
    backgroundImage: '',
    textPadding: {},
    isLanscape: false,
    page: 0,
    rowsPerPage: 0,
    showPagination: true,
    isAdmin: false,
    isReadOnly: false,
    isLoading: false,
  },
  actions: {
    handleChangePage: () => {},
    handleChangeRowsPerPage: () => {},
    handleSearch: () => {},
    handleEdit: () => {},
  },
};
